import { MutableRefObject } from 'react';

export enum AuthState {
  LOADING = 'loading',
  SIGNED_IN = 'signed_in',
  SIGN_IN = 'sign_in',
}

export interface AuthProviderState {
  authState: AuthState;
  user: any;
  session: { username: string } | null;
}

export interface AmpAccessToken {
  token: string;
  expiration: Date;
}

export interface AuthProvider {
  getInitialAuthState: () => Promise<AuthProviderState>;
  signIn: (username: string) => Promise<void>;
  signInIdp: (email: string) => Promise<void>;
  signOut: () => void;
  getToken: (force: boolean) => Promise<AmpAccessToken>;
}

export interface AuthCallbacks {
  authState: AuthState;
  loginUsername: string | null;
  resetAuthState: () => void;
  signIn: (username: string) => Promise<void>;
  signInIdp: (username: string) => Promise<void>;
  signOut: () => void;

  // preferred way of requesting a token, ensures that an unexpired token is returned
  getToken: (force?: boolean) => Promise<AmpAccessToken>;

  // reference to currently in use access token, useful for iframe components to watch for updates
  accessToken: MutableRefObject<AmpAccessToken | null>;
}
